// Styles
import '@mdi/font/css/materialdesignicons.css';
// eslint-disable-next-line import/no-unresolved, import/extensions
import 'vuetify/styles';

// Vuetify
import { createVuetify } from 'vuetify';

// eslint-disable-next-line function-paren-newline
export default createVuetify(
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
  // eslint-disable-next-line function-paren-newline
);
